import { useCallback } from "react";
import { useModalState } from "./useModalState";
import { useFormState } from "./useFormState";
import { useSignatureState } from "./useSignatureState";
import { useCartState } from "./useCartState";
import { useSearchState } from "./useSearchState";

/**
 * Main state management hook for Signature component
 * Combines all specialized state hooks into a single interface
 */
export const useSignatureStateManager = () => {
  // Get all state hooks
  const modalState = useModalState();
  const formState = useFormState();
  const signatureState = useSignatureState();
  const cartState = useCartState();
  const searchState = useSearchState();

  const { closeAllModals } = modalState;
  const { resetAddItemForm } = formState;
  const { resetAllSignatures } = signatureState;
  const { resetAllCarts } = cartState;
  const { resetSearch } = searchState;

  const resetAllState = useCallback(() => {
    closeAllModals();
    resetAddItemForm();
    resetAllSignatures();
    resetAllCarts();
    resetSearch();
  }, [
    closeAllModals,
    resetAddItemForm,
    resetAllSignatures,
    resetAllCarts,
    resetSearch,
  ]);

  return {
    // Modal state
    ...modalState,

    // Form state
    ...formState,

    // Signature state
    ...signatureState,

    // Cart state
    ...cartState,

    // Search state
    ...searchState,

    // Combined utilities
    resetAllState,
  };
};
